import axios from 'axios';

export default {
    methods: {
        async preguntaIndex(d, ok, err) {
            try {
                let r = await axios.get('pregunta?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async preguntaStore(d, ok, err) {
            try {
                let r = await axios.post('pregunta', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async preguntaUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('pregunta/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async preguntaShow(id, ok, err) {
            try {
                let r = await axios.get('pregunta/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async preguntaVincular(ok, err) {
            try {
                let r = await axios.post('pregunta/vincular');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async preguntaBuscar(d, ok, err) {
            try {
                let r = await axios.post('pregunta/buscar', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async preguntaTipos(ok, err) {
            try {
                let r = await axios.post('pregunta/tipos');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async preguntaOrden(d, ok, err) {
            try {
                let r = await axios.post('pregunta/orden', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/formulario/pregunta.js